var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59913 8C7.77013 8 7.91273 8.05325 8.02694 8.15974C8.14115 8.26624 8.19826 8.3992 8.19826 8.55864L8.19826 10.5896C8.19826 11.0655 8.37561 11.4674 8.73031 11.7955C9.08501 12.1236 9.51467 12.2876 10.0193 12.2876L15.9612 12.2876L14.1823 10.6289C14.0731 10.5271 14.0199 10.4012 14.0228 10.2511C14.0256 10.1011 14.0839 9.97046 14.1974 9.85926C14.3167 9.74807 14.4582 9.69247 14.6219 9.69247C14.7857 9.69247 14.9272 9.74807 15.0465 9.85926L17.8297 12.4544C17.8915 12.512 17.9353 12.5737 17.9612 12.6393C17.9871 12.7049 18 12.7739 18 12.8462C18 12.9186 17.9871 12.9876 17.9612 13.0532C17.9353 13.1188 17.8915 13.1804 17.8297 13.2381L15.0313 15.8473C14.9222 15.9491 14.7857 16 14.6219 16C14.4582 16 14.3167 15.9444 14.1974 15.8332C14.0782 15.722 14.0185 15.5914 14.0185 15.4414C14.0185 15.2913 14.0782 15.1607 14.1974 15.0495L15.9612 13.4049L10.0193 13.4049C9.18715 13.4049 8.47589 13.132 7.88553 12.5862C7.29518 12.0405 7 11.3749 7 10.5896L7 8.55864C7 8.3992 7.05711 8.26624 7.17132 8.15974C7.28553 8.05325 7.42813 8 7.59913 8Z",
    fill: "#0F1111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGo);
export default __webpack_public_path__ + "static/media/go.d4097748093f3a57d6b4a62c781ef8df.svg";
export { ForwardRef as ReactComponent };